module.exports = __webpack_public_path__ + "img/symbol_5.2e87ab60.png";